import { Link } from 'react-router'
import { LuCalendarDays } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { PageHero, heroPrimaryLink, heroSecondaryLink } from '@/components/ui/PageHero'
import { wombDiagram } from '@/assets/siteMedia'

export const WomensHealthHero = () => (
  <PageHero
    visual={
      <img
        src={wombDiagram}
        alt="Anatomical diagram of the womb, ovaries and fallopian tubes"
        loading="eager"
        width={436}
        height={313}
        className="w-full max-w-md rounded-3xl border border-white/10 bg-white p-4 shadow-xl sm:p-6"
      />
    }
    highlights={['Menarche to menopause', 'Hormonal balance', 'Fibroids & heavy bleeding']}
    title="Women's Health"
    accent="Specialist Support"
    description={
      <>
        <p>
          Supporting women from menarche to menopause and beyond using herbal medicine, nutrition,
          lifestyle guidance, and generations of traditional healing knowledge.
        </p>
        <p className="text-sm text-green-200">
          Kandake Makonnen · BSc (Hons) Medical Herbalist · 20+ years specialist experience
        </p>
      </>
    }
  >
    <Link to={`${ROUTES.CONTACT}?service=womens-health`} className={heroPrimaryLink}>
      Book a Consultation
      <LuCalendarDays aria-hidden="true" className="h-4 w-4 shrink-0" />
    </Link>
    <Link to={ROUTES.ABOUT} className={heroSecondaryLink}>
      About Kandake
    </Link>
  </PageHero>
)
